import {computed, type Ref} from "vue";

interface Options {
  defaultPageSize?: number
  pageNumberParam?: string
  pageSizeParam?: string
}

interface PaginationState {
  pageNumber: Ref<number>
  pageSize: Ref<number>
}

export function usePaginationParams(params: Record<string, string>, options: Options = {}): PaginationState {
  const {defaultPageSize = 20, pageNumberParam = "page", pageSizeParam = "size"} = options

  const pageNumber = computed<number>({
    get: () => Number(params[pageNumberParam] || 1) - 1,
    set: value => {
      params[pageNumberParam] = value ? String(value + 1) : '';
    },
  })

  const pageSize = computed<number>({
    get: () => Number(params[pageSizeParam] || defaultPageSize),
    set: value => {
      params[pageSizeParam] = value && (value !== defaultPageSize) ? String(value) : ''
    },
  })

  return {pageNumber, pageSize}
}
